import { useState } from "react";
import { categories, CategoryItem } from "@/mocks/categories";

interface CategoryDropdownProps {
  onSelect: (category: CategoryItem) => void;
}

export default function CategoryDropdown({ onSelect }: CategoryDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (category: CategoryItem) => {
    onSelect(category);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full max-w-md mx-auto">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full h-14 px-6 bg-white/95 backdrop-blur-sm rounded-full flex items-center justify-between text-foreground-700 text-sm hover:bg-white transition-all duration-200 cursor-pointer"
      >
        <span className="whitespace-nowrap truncate">Selecione uma categoria...</span>
        <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}>
          <i className="ri-arrow-down-s-line"></i>
        </span>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl border border-background-200/60 overflow-hidden z-50 max-h-[320px] overflow-y-auto">
          {categories.map((category) => (
            <a
              key={category.id}
              href={category.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => handleSelect(category)}
              className="flex items-center gap-3 px-6 py-3 text-sm text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer border-b border-background-100 last:border-b-0 whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center text-foreground-500">
                <i className={category.icon}></i>
              </span>
              {category.name}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}